import { useQuery } from "@tanstack/react-query";
import { getPresignTrackDocuments } from "../api/track-documents";
import { TrackDocumentType } from "../types";

export const useTrackDocumentQuery = ({
  documentType,
  uid,
}: {
  documentType: TrackDocumentType;
  uid?: string;
}) => {
  const query = useQuery({
    queryKey: ["track-documents", uid, documentType],
    queryFn: () => getPresignTrackDocuments({ uid, documentType }),
    enabled: !!uid && !!documentType,
  });
  return { ...query, data: query.data?.data };
};
